import type { jsPDF } from "jspdf";

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  const chunk = 8192;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk) as unknown as number[]);
  }
  return btoa(binary);
}

/**
 * Load Montserrat Regular and Bold into the jsPDF document.
 * Returns true if loaded, false otherwise (e.g. font files not found).
 */
export async function loadMontserrat(doc: jsPDF): Promise<boolean> {
  try {
    const regularModule = await import("./Montserrat-Regular.ttf?url");
    const boldModule = await import("./Montserrat-Bold.ttf?url");
    const regularUrl = (regularModule as { default: string }).default;
    const boldUrl = (boldModule as { default: string }).default;

    const [regularRes, boldRes] = await Promise.all([fetch(regularUrl), fetch(boldUrl)]);
    if (!regularRes.ok || !boldRes.ok) return false;

    const [regularBase64, boldBase64] = await Promise.all([
      regularRes.arrayBuffer().then(arrayBufferToBase64),
      boldRes.arrayBuffer().then(arrayBufferToBase64),
    ]);

    doc.addFileToVFS("Montserrat-Regular.ttf", regularBase64);
    doc.addFont("Montserrat-Regular.ttf", "Montserrat", "normal");
    doc.addFileToVFS("Montserrat-Bold.ttf", boldBase64);
    doc.addFont("Montserrat-Bold.ttf", "Montserrat", "bold");
    return true;
  } catch {
    return false;
  }
}
